// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"083d7357","488":"20ba66e9","977":"be06c92f"}[chunkId] + ".chunk.js";
};